import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LongUserName from '../layout/LongUserName';

export default class LoggedInUserName extends Component {
  static contextTypes = {
    session: PropTypes.object.isRequired
  };

  static propTypes = {};

  render() {
    const { session } = this.context;
    const { className, style } = this.props;

    return <LongUserName className={className} style={style} user={session.getUser()}/>;
  }
}